import axios from 'axios'
if (process.env.NODE_ENV == 'development'||process.env.NODE_ENV == 'debug') {
  axios.defaults.baseURL = window.vueConfig.development.apiHost;
  window.hostConfig.webApiHost= window.vueConfig.development.apiHost;
  window.hostConfig.videoHost= window.vueConfig.development.videoHost;
  window.hostConfig.imageHost= window.vueConfig.development.imageHost;
}
else if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = window.vueConfig.production.apiHost;
  window.hostConfig.webApiHost= window.vueConfig.production.apiHost;
  window.hostConfig.videoHost= window.vueConfig.production.videoHost;
  window.hostConfig.imageHost= window.vueConfig.production.imageHost;
}
function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err.data && err.data.message ? err.data.message : '网络好像出了点问题~~');
      })
      .catch((error) => {
        reject(error)
      })
  })
}

function get(url, param) {
  return new Promise((resolve, reject) => {
    axios.get(url, { params: param })
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export default { post, get }


// WEBPACK FOOTER //
// ./src/api/http.js